
export const products = [
  {
    id: 1,
    name: 'Professional Massage Table',
    category: 'Spa Equipment',
    description: 'Premium adjustable massage table with memory foam padding, perfect for spa and wellness centers. Features sturdy construction and easy height adjustment.',
    image: 'https://public.readdy.ai/ai/img_res/3c4530afe9d94e84be913858c88cc206.jpg'
  },
  {
    id: 2,
    name: 'Facial Steamer Pro',
    category: 'Salon Equipment',
    description: 'Advanced facial steamer with ozone function for deep cleansing treatments. Adjustable arm and timer settings for professional salon use.',
    image: 'https://readdy.ai/api/search-image?query=modern%20facial%20steamer%20equipment%20white%20color%20with%20adjustable%20arm%20professional%20salon%20device%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod2&orientation=squarish'
  },
  {
    id: 3,
    name: 'LED Light Therapy Device',
    category: 'Medical Equipment',
    description: 'Multi-wavelength LED therapy device for skin rejuvenation and treatment. FDA-approved technology with multiple treatment modes.',
    image: 'https://readdy.ai/api/search-image?query=led%20light%20therapy%20device%20for%20skin%20treatment%20modern%20medical%20equipment%20with%20colorful%20lights%20professional%20healthcare%20device%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod3&orientation=squarish'
  },
  {
    id: 4,
    name: 'Salon Chair Deluxe',
    category: 'Salon Furniture',
    description: 'Ergonomic hydraulic salon chair with premium leather upholstery. 360-degree rotation and adjustable height for maximum comfort.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20salon%20chair%20black%20leather%20hydraulic%20base%20chrome%20finish%20modern%20design%20professional%20hairstyling%20chair%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod4&orientation=squarish'
  },
  {
    id: 5,
    name: 'Hot Towel Cabinet',
    category: 'Spa Equipment',
    description: 'UV sterilizer hot towel warmer cabinet with large capacity. Maintains optimal temperature and hygiene for spa towels.',
    image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20hot%20towel%20cabinet%20warmer%20with%20glass%20door%20modern%20spa%20equipment%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod5&orientation=squarish'
  },
  {
    id: 6,
    name: 'Ultrasonic Skin Scrubber',
    category: 'Medical Equipment',
    description: 'Professional ultrasonic skin scrubber for deep cleansing and exfoliation. Gentle yet effective for all skin types.',
    image: 'https://readdy.ai/api/search-image?query=ultrasonic%20skin%20scrubber%20handheld%20device%20white%20color%20modern%20medical%20beauty%20tool%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod6&orientation=squarish'
  },
  {
    id: 7,
    name: 'Pedicure Spa Chair',
    category: 'Salon Equipment',
    description: 'Luxurious pedicure spa chair with massage function and built-in basin. Premium comfort for nail salon services.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20pedicure%20spa%20chair%20with%20massage%20function%20modern%20nail%20salon%20furniture%20elegant%20design%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod7&orientation=squarish'
  },
  {
    id: 8,
    name: 'Microdermabrasion Machine',
    category: 'Medical Equipment',
    description: 'Diamond microdermabrasion system for professional skin resurfacing. Multiple intensity levels and treatment tips included.',
    image: 'https://readdy.ai/api/search-image?query=microdermabrasion%20machine%20professional%20medical%20device%20white%20color%20with%20digital%20display%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod8&orientation=squarish'
  },
  {
    id: 9,
    name: 'Hair Steamer',
    category: 'Salon Equipment',
    description: 'Professional hair steamer for deep conditioning treatments. Adjustable timer and temperature control for optimal results.',
    image: 'https://readdy.ai/api/search-image?query=professional%20hair%20steamer%20salon%20equipment%20white%20color%20with%20hood%20adjustable%20stand%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod9&orientation=squarish'
  },
  {
    id: 10,
    name: 'Wax Warmer Station',
    category: 'Spa Equipment',
    description: 'Multi-pot wax warmer station with precise temperature control. Perfect for professional waxing services.',
    image: 'https://readdy.ai/api/search-image?query=professional%20wax%20warmer%20station%20multiple%20pots%20temperature%20control%20modern%20spa%20equipment%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod10&orientation=squarish'
  },
  {
    id: 11,
    name: 'Oxygen Facial Machine',
    category: 'Medical Equipment',
    description: 'Advanced oxygen therapy system for facial rejuvenation. Delivers pure oxygen and serums for glowing skin.',
    image: 'https://readdy.ai/api/search-image?query=oxygen%20facial%20machine%20medical%20beauty%20device%20white%20color%20modern%20design%20professional%20equipment%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod11&orientation=squarish'
  },
  {
    id: 12,
    name: 'Styling Station',
    category: 'Salon Furniture',
    description: 'Modern styling station with large mirror and storage. Durable construction with elegant design for any salon.',
    image: 'https://readdy.ai/api/search-image?query=modern%20salon%20styling%20station%20with%20large%20mirror%20storage%20drawers%20black%20and%20white%20design%20professional%20furniture%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod12&orientation=squarish'
  },
  {
    id: 13,
    name: 'Paraffin Wax Bath',
    category: 'Spa Equipment',
    description: 'Therapeutic paraffin wax bath for hands and feet. Maintains consistent temperature for soothing treatments.',
    image: 'https://readdy.ai/api/search-image?query=paraffin%20wax%20bath%20spa%20equipment%20white%20color%20temperature%20control%20modern%20design%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod13&orientation=squarish'
  },
  {
    id: 14,
    name: 'High Frequency Device',
    category: 'Medical Equipment',
    description: 'Professional high frequency device for acne treatment and skin tightening. Multiple electrode attachments included.',
    image: 'https://readdy.ai/api/search-image?query=high%20frequency%20device%20medical%20beauty%20tool%20with%20glass%20electrodes%20professional%20equipment%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod14&orientation=squarish'
  },
  {
    id: 15,
    name: 'Manicure Table',
    category: 'Salon Furniture',
    description: 'Ergonomic manicure table with built-in dust collector and LED lamp. Comfortable workspace for nail technicians.',
    image: 'https://readdy.ai/api/search-image?query=modern%20manicure%20table%20with%20dust%20collector%20led%20lamp%20white%20color%20professional%20nail%20salon%20furniture%20clean%20white%20background%20product%20photography&width=600&height=600&seq=prod15&orientation=squarish'
  }
];
